import Toast from 'helper/toast';
import { useCallback, useState } from 'react'

export default function useHttp(isLoading = true) {
    const [loading, setLoading] = useState(isLoading);
    const [isUploading, setIsUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const request = useCallback(async ({ url, title, values, isFile, isMulty }) => {
        isFile && setUploadProgress(0)
        isFile && setIsUploading(true)
        !isMulty && setLoading(true);
        var res = await url(values);
        !isMulty && setLoading(false);
        isFile && setIsUploading(false)

        if (!res.ok) {
            if (res.data?.code) {
                switch (res.data.code) {
                    case 3:
                        return Toast({ type: 'login' })
                    case 1:
                        return Toast({ type: 'register' })
                    case 52:
                        return Toast({ type: 'custom', title: 'این کد تخفیف ثبلا ثبت شده' })
                    case 69:
                        return
                    default:
                        return Toast({ type: 'err' })
                }
            } else {
                return Toast({ type: 'err', title })
            }

        }

        return res.data;
    }, [])

    return { request, loading, setLoading, uploadProgress, setUploadProgress, isUploading }

}
